const MessageSection = () => {
  return (
    <section id="about" className="py-24 lg:py-40 px-6 lg:px-0 bg-[#f5f0e8]">
      <div className="max-w-5xl mx-auto">
        <div className="relative">
          <p className="text-gray-700 text-xl lg:text-3xl leading-loose font-light">
            人生の道のりで、
            <br />
            困難にぶつかることがある。
            <br />
            不安な明日を前に、
            <br />
            誰かの助けが必要なこともある。
          </p>
          <div className="absolute -top-4 right-0 lg:right-20 w-32 lg:w-44 opacity-60">
            <img
              src="https://readdy.ai/api/search-image?query=soft%20watercolor%20illustration%20of%20green%20leaves%20and%20gentle%20nature%20motif%20minimal%20Japanese%20style%20pastel%20background&width=300&height=300&seq=msg_illust1&orientation=squarish"
              alt=""
              className="w-full h-auto rounded-full"
            />
          </div>
        </div>

        <div className="mt-16 lg:mt-24 lg:ml-32">
          <p className="text-gray-700 text-xl lg:text-3xl leading-loose font-light">
            私たちみどり苑はそんな時、
            <br />
            「あなたらしいくらし」を守ります。
            <br />
            地域に根ざした歴史と信頼。
            <br />
            老人ホームからデイサービス、
            <br />
            在宅介護、障がい者支援まで—
          </p>
        </div>

        <div className="mt-12 lg:mt-16 flex justify-start">
          <div className="w-48 lg:w-64 h-48 lg:h-64 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=elderly%20Japanese%20woman%20smiling%20warmly%20with%20caregiver%20in%20bright%20sunlit%20care%20facility%20garden%20flowers%20blooming%20peaceful%20atmosphere&width=400&height=400&seq=msg_img1&orientation=squarish"
              alt="ご利用者とスタッフ"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-16 lg:mt-20">
          <p className="text-gray-700 text-xl lg:text-3xl leading-loose font-light">
            あなたの「できない」を「できる」にしていく。
            <br />
            あなたの「不安」を「安心」で包みこむ。
            <br />
            あなたと家族の絆を、もう一度つよく結ぶ。
          </p>
        </div>

        <div className="mt-12 flex justify-end">
          <div className="w-48 lg:w-64 h-48 lg:h-64 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=caregiver%20holding%20hands%20with%20elderly%20person%20in%20warm%20sunlit%20room%20gentle%20caring%20moment%20Japanese%20care%20home%20natural%20light&width=400&height=400&seq=msg_img2&orientation=squarish"
              alt="寄り添うスタッフ"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-16 lg:mt-20">
          <p className="text-gray-700 text-2xl lg:text-4xl leading-loose font-light">
            私たちは、
            <br />
            あなたのくらしに寄り添う家族に近いもの、
            <br />
            あなたの「よりどころ」みどり苑です。
          </p>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
